import React from 'react';
import axios from 'axios';

export const API_URL = process.env.REACT_APP_BIGC_BIGLINE_API_URL;
export const API_KEY = process.env.REACT_APP_BIGC_BIGLINE_API_KEY;
export const api = (path, timeout = 60000) => axios.get(`${API_URL}/game-bts/admin/${path}`, { headers: { 'x-api-key': API_KEY }, timeout });
export const PAGE_SIZE = 10;

// CSV escape: long numeric IDs (12+ digits, BigPoint 15-16 หลัก) ห่อเป็น formula `="..."`
// กัน Excel แปลงเป็น scientific (7.71811E+15) ตอนเปิดด้วย double-click
const escapeCSV = (v) => {
  if (v === null || v === undefined) return '""';
  const s = String(v);
  if (/^\d{12,}$/.test(s)) return `"=""${s}"""`;
  return `"${s.replace(/"/g, '""')}"`;
};

export const downloadCSV = (headers, rows, filename) => {
  if (!rows.length) return;
  const bom = '\uFEFF';
  const csv = bom + [headers.join(','), ...rows.map(r => r.map(escapeCSV).join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = filename; a.click();
};

export const Badge = ({ color, children }) => <span className={`bts-admin__badge bts-admin__badge--${color}`}>{children}</span>;

export const Pagination = ({ total, page, setPage }) => {
  const totalPages = Math.ceil(total / PAGE_SIZE);
  if (totalPages <= 1) return null;
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) pages.push(i);
    else if (pages[pages.length - 1] !== '...') pages.push('...');
  }
  return (
    <div className="bts-admin__pagination">
      <button className="bts-admin__page-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>←</button>
      {pages.map((p, i) => p === '...' ? <span key={i}>...</span> : (
        <button key={i} className={`bts-admin__page-btn ${p === page ? 'bts-admin__page-btn--active' : ''}`} onClick={() => setPage(p)}>{p}</button>
      ))}
      <button className="bts-admin__page-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>→</button>
      <span className="bts-admin__page-info">{total} รายการ</span>
    </div>
  );
};

export const paginate = (arr, page) => arr ? arr.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE) : [];

export const SearchBox = ({ value, onChange, placeholder = 'ค้นหา...' }) => (
  <input
    type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
    className="bts-admin__search"
  />
);

export const searchFilter = (arr, query, fields) => {
  if (!query || !arr) return arr;
  const q = query.toLowerCase();
  return arr.filter(item => fields.some(f => {
    const val = typeof f === 'function' ? f(item) : item[f];
    return val && String(val).toLowerCase().includes(q);
  }));
};
